import { CommonModule } from "@angular/common";
import { NgModule, ModuleWithProviders } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NgxPaginationModule } from "ngx-pagination";

import { AppSessionService } from "./session/app-session.service";
import { AppUrlService } from "./nav/app-url.service";
import { AppAuthService } from "./auth/app-auth.service";
import { AppRouteGuard } from "./auth/auth-route-guard";
import { LocalizePipe } from "@shared/pipes/localize.pipe";

import { AbpPaginationControlsComponent } from "./components/pagination/abp-pagination-controls.component";
import { AbpValidationSummaryComponent } from "./components/validation/abp-validation.summary.component";
import { AbpModalHeaderComponent } from "./components/modal/abp-modal-header.component";
import { AbpModalFooterComponent } from "./components/modal/abp-modal-footer.component";
import { LayoutStoreService } from "./layout/layout-store.service";

import { BusyDirective } from "./directives/busy.directive";
import { EqualValidator } from "./directives/equal-validator.directive";
import { NgSelectModule } from "@ng-select/ng-select";

import { MenuModule } from "primeng/menu";

import { MomentPipe } from "@shared/pipes/moment.pipe";
import { FileSizePipe } from "@shared/pipes/file-size.pipe";
import { PercentagePipe } from "@shared/pipes/percentage.pipe";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { CarPlateComponent } from "@shared/components/car-plate/car-plate.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ImageUpload } from "@shared/components/image-upload/image-upload.component";
import { FileUploadService } from "./components/image-upload/file-upload.service";
import { AppSelectComponent } from "./components/app-select/app-select.component";
import { EntityTypeHistoryModalComponent } from "./components/entityHistory/entity-type-history-modal.component";
import { EntityChangeDetailModalComponent } from "./components/entityHistory/entity-change-detail-modal.component";
import { FileDownloadService } from "./services/file-download.service";
import { AppAttachmentsComponent } from "./components/app-attachments/app-attachments.component";
import { AppNotesComponent } from "./components/app-notes/app-notes.component";
import { ExportExcelService } from "./services/export-excel.service";
import { ApiFilesService } from "./services/api.files.service";
import { TimelineModule } from "primeng/timeline";
import { CardModule } from "primeng/card";
import { CalendarModule } from "primeng/calendar";
import { DialogService, DynamicDialogModule } from "primeng/dynamicdialog";
import { JsonViewerComponent } from "./components/json-viewer/json-viewer.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgxPaginationModule,
    NgSelectModule,
    MenuModule,
    PaginationModule.forRoot(),
    BsDatepickerModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    TimelineModule,
    CardModule,
  ],
  declarations: [
    AbpPaginationControlsComponent,
    AbpValidationSummaryComponent,
    AbpModalHeaderComponent,
    AbpModalFooterComponent,
    CarPlateComponent,
    LocalizePipe,
    BusyDirective,
    EqualValidator,
    MomentPipe,
    FileSizePipe,
    PercentagePipe,
    ImageUpload,
    AppSelectComponent,
    EntityChangeDetailModalComponent,
    EntityTypeHistoryModalComponent,
    AppAttachmentsComponent,
    AppNotesComponent,
    JsonViewerComponent
  ],
  exports: [
    AbpPaginationControlsComponent,
    AbpValidationSummaryComponent,
    AbpModalHeaderComponent,
    CarPlateComponent,
    AbpModalFooterComponent,
    LocalizePipe,
    BusyDirective,
    EqualValidator,
    NgSelectModule,
    MenuModule,
    MomentPipe,
    FileSizePipe,
    PercentagePipe,
    PaginationModule,
    NgxPaginationModule,
    BsDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    ImageUpload,
    JsonViewerComponent,
    AppSelectComponent,
    EntityChangeDetailModalComponent,
    EntityTypeHistoryModalComponent,
    AppAttachmentsComponent,
    AppNotesComponent,
    TimelineModule,
    CardModule,
    CalendarModule,
    DynamicDialogModule
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        AppSessionService,
        AppUrlService,
        AppAuthService,
        AppRouteGuard,
        LayoutStoreService,
        FileUploadService,
        FileDownloadService,
        ExportExcelService,
        ApiFilesService,
        DialogService
      ],
    };
  }
}
